/*
 * discover-lx1-book-demo.js — the "Book your free demo" popup in sections/discover-lx1-industries.liquid, also used
 * through snippets/book-demo-modal.liquid (LX1 demo page, sections/lx1-demo-cta.liquid).
 * Styles: assets/discover-lx1-book-demo.css. No dependencies.
 *
 * Openers: the Discover button #book-demo-popup, and any element with [data-bdp-open]. An opener can set
 * data-bdp-location / data-bdp-cta to label its dataLayer click (defaults: book-a-demo / popup-button).
 *
 * Moves the popup to the end of <body> (so no section can sit on top of it), preloads the Calendly iframe when the
 * button nears the viewport or the page goes idle, opens on click (pushes `book_demo_cta_click` to the dataLayer),
 * and closes on the close button, the backdrop or Escape. Passes the page's utm_ parameters through to Calendly and
 * sets embed_domain so Calendly can report bookings back (GA4 + Meta). Moved from an inline <script> on the Instant page.
 *
 * A page can render the popup snippet from more than one section (the accuracy page: LX1 band and FAQ), so this runs
 * once per page and keeps only the first popup; every opener on the page uses it.
 */
(function () {
  if (window.__bdpPopup) return;
  window.__bdpPopup = true;
  var openers = Array.prototype.slice.call(document.querySelectorAll('#book-demo-popup, [data-bdp-open]'));
  var modal = document.getElementById('bdp-modal');
  if (!openers.length || !modal) return;
  Array.prototype.forEach.call(document.querySelectorAll('[id="bdp-modal"]'), function (m) { if (m !== modal) m.remove(); });
  var lastOpener = openers[0];
  // The booking page comes from the section setting "Calendly booking link" (data-calendly-url on the popup).
  var CALENDLY_URL = modal.getAttribute('data-calendly-url') || 'https://calendly.com/d/dvwn-y4q-8dp/30-minute-moasure-demo?primary_color=1a8976&hide_gdpr_banner=1';
  // Move the popup to the end of <body> so no page section can sit on top of it.
  document.body.appendChild(modal);
  var frame = modal.querySelector('.bdp-frame');
  var closeBtn = modal.querySelector('.bdp-close');

  // Build the calendar address: embed_domain lets Calendly send booking events back to the page
  // (GA4 + Meta tracking), and any utm_ tags on the page URL are passed on so Calendly credits the ad.
  function calendlySrc() {
    var u = new URL(CALENDLY_URL);
    u.searchParams.set('embed_domain', location.hostname);
    u.searchParams.set('embed_type', 'PopupWidget');
    var q = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      if (q.get(k)) u.searchParams.set(k, q.get(k));
    });
    return u.toString();
  }

  // Start loading the calendar in the background as soon as someone shows interest,
  // so it's usually ready by the time they click.
  var iframe = null;
  function preload() {
    if (iframe) return;
    iframe = document.createElement('iframe');
    iframe.title = 'Book your free demo';
    iframe.src = calendlySrc();
    iframe.onload = function () {
      var sp = frame.querySelector('.bdp-spinner');
      if (sp) sp.remove();
    };
    frame.appendChild(iframe);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        if (
          entries.some(function (e) {
            return e.isIntersecting;
          })
        ) {
          preload();
          io.disconnect();
        }
      },
      { rootMargin: '300px' },
    );
    openers.forEach(function (o) {
      io.observe(o);
    });
  }
  // Also start once the page has finished loading (waiting for a quiet moment so it never slows
  // the page itself), so the calendar is ready even if the button is far down the page.
  function preloadWhenIdle() {
    (
      window.requestIdleCallback ||
      function (cb) {
        setTimeout(cb, 200);
      }
    )(preload, { timeout: 3000 });
  }
  if (document.readyState === 'complete') preloadWhenIdle();
  else window.addEventListener('load', preloadWhenIdle);
  openers.forEach(function (o) {
    ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
      o.addEventListener(ev, preload, { once: true, passive: true });
    });
  });

  var prevOverflow = '';
  function open() {
    preload();
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    closeBtn.focus();
  }
  function close() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = prevOverflow;
    lastOpener.focus();
  }

  openers.forEach(function (o) {
    o.addEventListener('click', function (e) {
      e.preventDefault(); // an opener may be a link to /pages/book-a-demo (the no-JS fallback)
      lastOpener = o;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'book_demo_cta_click',
        location: o.getAttribute('data-bdp-location') || 'book-a-demo',
        cta: o.getAttribute('data-bdp-cta') || 'popup-button',
      });
      open();
    });
  });
  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) close();
  }); // click the dark backdrop
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
